import { BehaviorSubject } from "rxjs";

export const error$ = new BehaviorSubject<any>(null);
